meedy.factory('meedy.priceListModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.priceListService',
    function($rootScope, applicationModel, baseModel, priceListService) {

        function PriceListModel() {

            this.savePricelist = function(resourcePriceList) {
                applicationModel.actionInProgress = true;
                priceListService.savePricelist(resourcePriceList).then(
                    function (list) {
                        baseModel.broadcastOperationSucceeded();
                        $rootScope.$broadcast(Event.MEEDY.PRICE_LIST.SAVE_PRICE_LIST.SUCCESS, list);
                        applicationModel.actionInProgress = false;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.PRICE_LIST.SAVE_PRICE_LIST.ERROR, error);
                        applicationModel.actionInProgress = false;
                    }
                )
            };
        }

        return new PriceListModel();
    }
]);
